import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

/** Shared editorial page hero: overline + display title (with italic accent) + intro. */
export const PageHero = ({ overline, titleA, titleAccent, titleB, intro, children }) => (
  <section className="pt-40 pb-16 md:pb-20 bg-[var(--bg)] border-b border-[var(--line-strong)]">
    <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
      <div className="md:col-span-4">
        <p className="overline mb-6">{overline}</p>
      </div>
      <div className="md:col-span-8">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE }}
          className="font-display text-4xl sm:text-5xl md:text-7xl tracking-[-0.03em] leading-[0.95] text-[var(--ink)]"
        >
          {titleA}{" "}
          <span className="font-serif-accent italic text-[var(--accent)]">{titleAccent}</span>{" "}
          {titleB}
        </motion.h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2, ease: EASE }}
            className="mt-8 text-[var(--ink-80)] text-base md:text-lg leading-relaxed max-w-2xl"
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
    </div>
  </section>
);

export default PageHero;
